import { Button, Grid2, Typography } from '@mui/material'
import React from 'react'
import { Link as ReactRouterLink, useHistory, useParams } from 'react-router-dom'
import CommonPageWrapper from '../../../common/components/CommonPageWrapper'
import Loader from '../../../common/loader/Loader'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index/index'
import { fetchExpressCheckoutScheduleById } from '../expressCheckoutQueries'
import { RestaurantCategorySchedule, RestaurantMenu } from '../types'
import { ExpressCheckoutScheduleForm } from './ExpressCheckoutScheduleForm'

export function EditSchedulePage() {
  const { stationId, scheduleId } = useParams<{ stationId: string; scheduleId: string }>()
  const history = useHistory()
  if (!scheduleId) {
    return (
      <CommonPageWrapper title={i18n.t('restaurantMenu.updateScheduleTitle')}>
        <Grid2 container direction='row' justifyContent='left'>
          <Grid2>
            <Button component={ReactRouterLink} variant='outlined' to={`/pikakassa/${stationId}/poikkeusaukioloajat`}>
              {i18n.t('buttons.back')}
            </Button>
          </Grid2>
        </Grid2>
        <Typography variant='h4' sx={{ marginTop: '80px' }}>
          {i18n.t('restaurantMenu.updateScheduleTitle')}
        </Typography>
      </CommonPageWrapper>
    )
  }
  return (
    <CommonPageWrapper title={i18n.t('restaurantMenu.updateScheduleTitle')}>
      <Grid2 container direction='row' justifyContent='left'>
        <Grid2>
          <Button component={ReactRouterLink} variant='outlined' to={`/pikakassa/${stationId}/poikkeusaukioloajat`}>
            {i18n.t('buttons.back')}
          </Button>
        </Grid2>
      </Grid2>
      <Query<
        {
          expressCheckoutSchedule?: RestaurantCategorySchedule
          expressCheckoutMenu?: RestaurantMenu
          expressCheckoutSchedules?: RestaurantCategorySchedule[]
        },
        { id: string; stationId: string }
      >
        query={fetchExpressCheckoutScheduleById}
        variables={{ id: scheduleId, stationId: decodeURIComponent(stationId || '') }}
      >
        {({ data, loading }) => {
          return (
            <Loader loading={loading}>
              <ExpressCheckoutScheduleForm
                scheduleToBeEdited={data?.expressCheckoutSchedule}
                existingSchedules={
                  data?.expressCheckoutSchedules?.filter((schedule) => schedule.id !== scheduleId) ?? []
                }
                menu={data?.expressCheckoutMenu}
                stationId={stationId}
                onCompleted={() => history.push(`/pikakassa/${stationId}/poikkeusaukioloajat`)}
              />
            </Loader>
          )
        }}
      </Query>
    </CommonPageWrapper>
  )
}
